import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_home",
  "use": "svg_home-usage",
  "viewBox": "0 0 23 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 19\" id=\"svg_home\"><path d=\"M4.553 17.571V7.588a2 2 0 0 1 .706-1.525L11.253.978a1 1 0 0 1 1.294 0l5.994 5.085a2 2 0 0 1 .706 1.525v9.983m-14.694 0H1.614m2.939 0h4.776m9.918 0h2.939m-2.94 0h-4.775m0 0H9.33m5.142 0v-5.714H9.33v5.714\" stroke=\"#16161D\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol